module.exports = __webpack_public_path__ + "static/media/IMG_20180804_095424.44d647ea.jpg";